import { checkoutConfig } from '../../constants/checkout';
import { cloneDeep } from 'lodash-es';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DeliveryOptionType, DropOffOptionType } from '../../types/checkout-common';
import {
  CheckoutState,
  ResetStepperProgressPayload,
  SaveFormDataPayload,
} from '../../types/checkout-state';

export const initialState: CheckoutState = {
  stepper: {
    jobsiteDetails: {},
    deliveryDetails: {},
    billingDetails: {},
    review: {},
  },
};

const checkoutSlice = createSlice({
  name: 'checkout',
  initialState,
  reducers: {
    saveFormData: (state, action: PayloadAction<SaveFormDataPayload>) => {
      state.stepper[action.payload.stepKey].formData = cloneDeep(action.payload.formData);
      state.stepper[action.payload.stepKey].isComplete = true;
    },
    /**
     * Update delivery form state when mode of delivery is updated.
     */
    modeOfDeliveryChange: (state, action: PayloadAction<DeliveryOptionType>) => {
      state.stepper.deliveryDetails.formData = {
        ...state.stepper.deliveryDetails.formData,
        modeOfDelivery: action.payload,
      };
    },
    /**
     * Update delivery form state when mode of returning is updated.
     */
    modeOfReturningChange: (state, action: PayloadAction<DropOffOptionType>) => {
      state.stepper.deliveryDetails.formData = {
        ...state.stepper.deliveryDetails.formData,
        modeOfReturning: action.payload,
      };
    },
    updateStepperProgress: (state, action: PayloadAction<ResetStepperProgressPayload>) => {
      const index = checkoutConfig.stepperOrder.findIndex((e) => e === action.payload.stepKey);
      checkoutConfig.stepperOrder.forEach((_e, i) => {
        if (i < index) {
          state.stepper[checkoutConfig.stepperOrder[i]].isComplete = true;
        } else {
          state.stepper[checkoutConfig.stepperOrder[i]].isComplete = false;
        }
      });
    },
    clearForm: () => {
      return { ...initialState };
    },
    resetJobsiteDetails: (state) => {
      state.stepper.jobsiteDetails.formData = {
        ...state.stepper.jobsiteDetails.formData,
        jobsiteSelectionType: null,
        jobsiteLocationId: null,
        jobsiteName: '',
        latitudeLongitude: null,
        address: '',
        city: '',
        zip: '',
      };

      const index = checkoutConfig.stepperOrder.findIndex((e) => e === 'jobsiteDetails');
      checkoutConfig.stepperOrder.forEach((_e, i) => {
        if (i < index) {
          state.stepper[checkoutConfig.stepperOrder[i]].isComplete = true;
        } else {
          state.stepper[checkoutConfig.stepperOrder[i]].isComplete = false;
        }
      });
    },
    resetStepper: (state) => {
      checkoutConfig.stepperOrder.forEach((_e, i) => {
        state.stepper[checkoutConfig.stepperOrder[i]].isComplete = false;
      });
    },
  },
});

export const {
  saveFormData,
  updateStepperProgress,
  modeOfDeliveryChange,
  modeOfReturningChange,
  clearForm,
  resetStepper,
  resetJobsiteDetails,
} = checkoutSlice.actions;

export default checkoutSlice.reducer;
